import { ToastContainer, toast } from 'react-toastify';
import React, { useState, useEffect, useCallback, useRef } from 'react';
import {
  Controls,
  Background,
  ReactFlow,
  ReactFlowProvider,
  useNodesState,
  useEdgesState,
  addEdge,
  reconnectEdge,
  useReactFlow,
  Panel,
  // MarkerType,
} from '@xyflow/react';
import { useParams } from 'react-router-dom'
import '@xyflow/react/dist/style.css';

const flowKey = 'example-flow';
const getNodeId = () => `randomnode_${+new Date()}`;

const defaultEdgeOptions = {
  // animated: true,
  // type: 'straight',
  // type: 'bezier',
  // style: {
  //   stroke: 'skyblue',
  //   strokeWidth: 2,
  // },

  // type: 'floating',
  // markerEnd: {
  //   type: MarkerType.Arrow,
  //   color: '#b1b1b7',
  // },
};

const snapGrid = [5, 5];
// const edgeTypes = {
//   smart: SmartBezierEdge,
// }

const initialNodes = //JSON.parse(localStorage.getItem(flowKey)).nodes//
  [{ "id": "1", "data": { "label": "Lenguaje" }, "type": "input", "sourcePosition": "right", "targetPosition": "left", "position": { "x": 0, "y": -210 }, "measured": { "width": 150, "height": 39 }, "selected": false, "dragging": false }, { "id": "2", "data": { "label": "Matemática" }, "type": "input", "sourcePosition": "right", "targetPosition": "left", "position": { "x": 0, "y": -90 }, "measured": { "width": 150, "height": 39 }, "selected": false, "dragging": false }, { "id": "3", "data": { "label": "Sistemas de representación" }, "type": "input", "sourcePosition": "right", "targetPosition": "left", "position": { "x": 0, "y": 65 }, "measured": { "width": 150, "height": 56 }, "selected": false, "dragging": false }, { "id": "4", "data": { "label": "Metodologia" }, "type": "input", "sourcePosition": "right", "targetPosition": "left", "position": { "x": 0, "y": 255 }, "measured": { "width": 150, "height": 39 }, "selected": false, "dragging": false }, { "id": "5", "data": { "label": "Ingles I" }, "type": "input", "sourcePosition": "right", "targetPosition": "left", "position": { "x": 0, "y": 205 }, "measured": { "width": 150, "height": 39 }, "selected": false, "dragging": false }, { "id": "7", "data": { "label": "Teoria del diseño" }, "sourcePosition": "right", "targetPosition": "left", "position": { "x": 195, "y": 105 }, "measured": { "width": 150, "height": 39 }, "selected": false, "dragging": false, "style": { "backgroundColor": "" } }, { "id": "8", "data": { "label": "Arte prehistórico" }, "type": "input", "sourcePosition": "right", "targetPosition": "left", "position": { "x": 195, "y": 155 }, "measured": { "width": 150, "height": 39 }, "selected": false, "dragging": false, "style": { "backgroundColor": "skyblue" } }, { "id": "9", "data": { "label": "Ingles II" }, "sourcePosition": "right", "targetPosition": "left", "position": { "x": 195, "y": 205 }, "measured": { "width": 150, "height": 39 }, "selected": false, "dragging": false }, { "id": "10", "data": { "label": "?" }, "sourcePosition": "right", "targetPosition": "left", "position": { "x": 195, "y": 255 }, "measured": { "width": 150, "height": 39 }, "selected": false, "dragging": false }, { "id": "11", "data": { "label": "Estadística descriptiva" }, "sourcePosition": "right", "targetPosition": "left", "position": { "x": 375, "y": -90 }, "measured": { "width": 150, "height": 39 }, "selected": false, "dragging": false }, { "id": "12", "data": { "label": "Semiótica" }, "sourcePosition": "right", "targetPosition": "left", "position": { "x": 375, "y": 100 }, "measured": { "width": 150, "height": 39 }, "selected": false, "dragging": false }, { "id": "13", "data": { "label": "Sicopatología" }, "sourcePosition": "right", "targetPosition": "left", "position": { "x": 375, "y": 200 }, "measured": { "width": 150, "height": 39 }, "selected": false, "dragging": false, "style": { "backgroundColor": "" } }, { "id": "14", "data": { "label": "Arte antiguo" }, "sourcePosition": "right", "targetPosition": "left", "position": { "x": 375, "y": 155 }, "measured": { "width": 150, "height": 39 }, "selected": false, "dragging": false, "style": { "backgroundColor": "skyblue" } }, { "id": "15", "data": { "label": "Escultura I" }, "sourcePosition": "right", "targetPosition": "left", "position": { "x": 375, "y": 50 }, "measured": { "width": 150, "height": 39 }, "selected": false, "dragging": false, "style": { "backgroundColor": "orange" } }, { "id": "16", "data": { "label": "Estadistica inferencial" }, "sourcePosition": "right", "targetPosition": "left", "position": { "x": 575, "y": -195 }, "measured": { "width": 150, "height": 39 }, "selected": false, "dragging": false }, { "id": "17", "data": { "label": "Biomecanica" }, "sourcePosition": "right", "targetPosition": "left", "position": { "x": 575, "y": -150 }, "measured": { "width": 150, "height": 39 }, "selected": false, "dragging": false }, { "id": "18", "data": { "label": "Modelado digital 3D I" }, "sourcePosition": "right", "targetPosition": "left", "position": { "x": 575, "y": -45 }, "measured": { "width": 150, "height": 39 }, "selected": false, "dragging": false, "style": { "backgroundColor": "moccasin" } }, { "id": "19", "data": { "label": "Arte medieval" }, "sourcePosition": "right", "targetPosition": "left", "position": { "x": 570, "y": 155 }, "measured": { "width": 150, "height": 39 }, "selected": false, "dragging": false, "style": { "backgroundColor": "skyblue" } }, { "id": "20", "data": { "label": "Escultura II" }, "sourcePosition": "right", "targetPosition": "left", "position": { "x": 575, "y": 50 }, "measured": { "width": 150, "height": 39 }, "selected": false, "dragging": false, "style": { "backgroundColor": "orange" } }, { "id": "21", "data": { "label": "Lógica" }, "sourcePosition": "right", "targetPosition": "left", "position": { "x": 750, "y": -50 }, "measured": { "width": 150, "height": 39 }, "selected": false, "dragging": false }, { "id": "22", "data": { "label": "Ontología" }, "sourcePosition": "right", "targetPosition": "left", "position": { "x": 750, "y": -5 }, "measured": { "width": 150, "height": 39 }, "selected": false, "dragging": false }, { "id": "23", "data": { "label": "Modelado digital 3D II" }, "sourcePosition": "right", "targetPosition": "left", "position": { "x": 750, "y": -110 }, "measured": { "width": 150, "height": 39 }, "selected": false, "dragging": false, "style": { "backgroundColor": "moccasin" } }, { "id": "24", "data": { "label": "Arte moderno" }, "sourcePosition": "right", "targetPosition": "left", "position": { "x": 750, "y": 155 }, "measured": { "width": 150, "height": 39 }, "selected": false, "dragging": false, "style": { "backgroundColor": "skyblue" } }, { "id": "25", "data": { "label": "Escultura III" }, "sourcePosition": "right", "targetPosition": "left", "position": { "x": 750, "y": 50 }, "measured": { "width": 150, "height": 39 }, "selected": false, "dragging": false, "style": { "backgroundColor": "orange" } }, { "id": "26", "data": { "label": "Epistemología" }, "sourcePosition": "right", "targetPosition": "left", "position": { "x": 950, "y": -5 }, "measured": { "width": 150, "height": 39 }, "selected": false, "dragging": false }, { "id": "27", "data": { "label": "Etetica" }, "sourcePosition": "right", "targetPosition": "left", "position": { "x": 950, "y": -85 }, "measured": { "width": 150, "height": 39 }, "selected": false, "dragging": false }, { "id": "28", "data": { "label": "Modelado escaneo e impresion 3D" }, "sourcePosition": "right", "targetPosition": "left", "position": { "x": 950, "y": -160 }, "measured": { "width": 150, "height": 56 }, "selected": false, "dragging": false, "style": { "backgroundColor": "moccasin" } }, { "id": "30", "data": { "label": "Escultura IV" }, "sourcePosition": "right", "targetPosition": "left", "position": { "x": 950, "y": 50 }, "measured": { "width": 150, "height": 39 }, "selected": false, "dragging": false, "style": { "backgroundColor": "orange" } }, { "id": "31", "data": { "label": "Metafisica" }, "sourcePosition": "right", "targetPosition": "left", "position": { "x": 1155, "y": -5 }, "measured": { "width": 150, "height": 39 }, "selected": false, "dragging": false }, { "id": "32", "data": { "label": "Deontología" }, "sourcePosition": "right", "targetPosition": "left", "position": { "x": 1155, "y": -85 }, "measured": { "width": 150, "height": 39 }, "selected": false, "dragging": false }, { "id": "33", "data": { "label": "Animaciones y render 3D" }, "sourcePosition": "right", "targetPosition": "left", "position": { "x": 1155, "y": -160 }, "measured": { "width": 150, "height": 56 }, "selected": false, "dragging": false, "style": { "backgroundColor": "moccasin" } }, { "id": "34", "data": { "label": "Arte cotemporaneo" }, "sourcePosition": "right", "targetPosition": "left", "position": { "x": 950, "y": 155 }, "measured": { "width": 150, "height": 39 }, "selected": false, "dragging": false, "style": { "backgroundColor": "skyblue" } }, { "id": "35", "data": { "label": "Escultura V" }, "sourcePosition": "right", "targetPosition": "left", "position": { "x": 1155, "y": 50 }, "measured": { "width": 150, "height": 39 }, "selected": false, "dragging": false, "style": { "backgroundColor": "orange" } }, { "id": "36", "data": { "label": "Realidad aumentada" }, "sourcePosition": "right", "targetPosition": "left", "position": { "x": 1360, "y": -170 }, "measured": { "width": 150, "height": 39 }, "selected": false, "dragging": false, "style": { "backgroundColor": "moccasin" } }, { "id": "37", "data": { "label": "Restauración" }, "sourcePosition": "right", "targetPosition": "left", "position": { "x": 1355, "y": 230 }, "measured": { "width": 150, "height": 39 }, "selected": false, "dragging": false, "style": { "backgroundColor": "" } }, { "id": "38", "data": { "label": "Videojuegos 3D" }, "sourcePosition": "right", "targetPosition": "left", "position": { "x": 1360, "y": -120 }, "measured": { "width": 150, "height": 39 }, "selected": true, "dragging": false, "style": { "backgroundColor": "moccasin" } }, { "id": "39", "data": { "label": "Sociologia" }, "sourcePosition": "right", "targetPosition": "left", "position": { "x": 1355, "y": 170 }, "measured": { "width": 150, "height": 39 }, "selected": false, "dragging": false, "style": { "backgroundColor": "" } }, { "id": "40", "data": { "label": "Escultura VI" }, "sourcePosition": "right", "targetPosition": "left", "position": { "x": 1355, "y": 50 }, "measured": { "width": 150, "height": 39 }, "selected": false, "dragging": false, "style": { "backgroundColor": "orange" } }, { "id": "41", "data": { "label": "Economia" }, "sourcePosition": "right", "targetPosition": "left", "position": { "x": 1545, "y": 110 }, "measured": { "width": 150, "height": 39 }, "selected": false, "dragging": false }, { "id": "42", "data": { "label": "Practicas preprofesionales I" }, "sourcePosition": "right", "targetPosition": "left", "position": { "x": 1545, "y": 215 }, "measured": { "width": 150, "height": 56 }, "selected": false, "dragging": false }, { "id": "43", "data": { "label": "Gestion empresarial" }, "sourcePosition": "right", "targetPosition": "left", "position": { "x": 1545, "y": 170 }, "measured": { "width": 150, "height": 39 }, "selected": false, "dragging": false }, { "id": "44", "data": { "label": "Tesis I" }, "sourcePosition": "right", "targetPosition": "left", "position": { "x": 1545, "y": -195 }, "measured": { "width": 150, "height": 39 } }, { "id": "45", "data": { "label": "Escultura VII" }, "sourcePosition": "right", "targetPosition": "left", "position": { "x": 1545, "y": 50 }, "measured": { "width": 150, "height": 39 }, "selected": false, "dragging": false, "style": { "backgroundColor": "orange" } }, { "id": "46", "data": { "label": "Practicas preprofesionales II" }, "sourcePosition": "right", "targetPosition": "left", "position": { "x": 1755, "y": 215 }, "type": "output", "measured": { "width": 150, "height": 56 }, "selected": false, "dragging": false, "style": { "backgroundColor": "" } }, { "id": "47", "data": { "label": "?" }, "sourcePosition": "right", "targetPosition": "left", "position": { "x": 1755, "y": 55 }, "type": "output", "measured": { "width": 150, "height": 39 }, "selected": false, "dragging": false }, { "id": "48", "data": { "label": "Proyectos artísticos culturales" }, "sourcePosition": "right", "targetPosition": "left", "position": { "x": 1755, "y": 140 }, "type": "output", "measured": { "width": 150, "height": 56 }, "selected": false, "dragging": false }, { "id": "49", "data": { "label": "Tesis II" }, "sourcePosition": "right", "targetPosition": "left", "position": { "x": 1755, "y": -195 }, "type": "output", "measured": { "width": 150, "height": 39 } }, { "id": "50", "data": { "label": "Software 3D" }, "sourcePosition": "right", "targetPosition": "left", "position": { "x": 1755, "y": -50 }, "type": "output", "measured": { "width": 150, "height": 39 }, "dragging": false, "selected": false, "style": { "backgroundColor": "orange" } }, { "id": "randomnode_1755441372527", "data": { "label": "Arte peruano" }, "position": { "x": 1155, "y": 155 }, "sourcePosition": "right", "targetPosition": "left", "measured": { "width": 150, "height": 39 }, "selected": false, "dragging": false, "style": { "backgroundColor": "skyblue" } }, { "id": "randomnode_1755443045461", "data": { "label": "Cálculo" }, "position": { "x": 200, "y": -140 }, "sourcePosition": "right", "targetPosition": "left", "measured": { "width": 150, "height": 39 }, "selected": false, "dragging": false, "style": { "backgroundColor": "" } }]


const initialEdges = //JSON.parse(localStorage.getItem(flowKey)).edges//
  [{ "id": "e1-3wwwww2w", "source": "5", "target": "8" }, { "id": "e1-4wwwww2w", "source": "5", "target": "9", "style": { "strokeWidth": 2, "stroke": "skyblue" }, "type": "smoothstep" }, { "id": "e1-3wwwwww2w", "source": "4", "target": "8" }, { "source": "12", "target": "19", "id": "xy-edge__12-19", "selected": false, "type": "bezier", "style": { "strokeWidth": "1", "stroke": "black" } }, { "source": "12", "target": "20", "id": "xy-edge__12-20" }, { "source": "11", "target": "16", "id": "xy-edge__11-16", "type": "smoothstep" }, { "source": "21", "target": "26", "id": "xy-edge__21-26" }, { "source": "21", "target": "27", "id": "xy-edge__21-27" }, { "source": "26", "target": "31", "id": "xy-edge__26-31" }, { "source": "16", "target": "44", "id": "xy-edge__16-44" }, { "source": "23", "target": "28", "id": "xy-edge__23-28", "selected": false, "type": "bezier", "style": { "strokeWidth": 2, "stroke": "skyblue" } }, { "source": "18", "target": "23", "id": "xy-edge__18-23" }, { "source": "17", "target": "23", "id": "xy-edge__17-23" }, { "source": "19", "target": "24", "id": "xy-edge__19-24" }, { "source": "33", "target": "38", "id": "xy-edge__33-38", "selected": false, "style": { "stroke": "magenta" } }, { "source": "28", "target": "33", "id": "xy-edge__28-33", "selected": false, "type": "bezier", "style": { "stroke": "blue" } }, { "source": "33", "target": "36", "id": "xy-edge__33-36", "selected": false, "style": { "strokeWidth": 2, "stroke": "skyblue" }, "type": "smoothstep" }, { "source": "42", "target": "46", "id": "xy-edge__42-46" }, { "source": "43", "target": "48", "id": "xy-edge__43-48", "selected": false, "type": "smoothstep", "style": { "strokeWidth": 2, "stroke": "skyblue" } }, { "source": "37", "target": "42", "id": "xy-edge__37-42", "selected": false, "style": { "strokeWidth": 2, "stroke": "skyblue" }, "type": "smoothstep" }, { "source": "39", "target": "43", "id": "xy-edge__39-43" }, { "source": "20", "target": "25", "id": "xy-edge__20-25", "selected": false, "style": { "strokeWidth": "3", "stroke": "orange" } }, { "source": "15", "target": "20", "id": "xy-edge__15-20", "type": "bezier", "selected": false, "style": { "strokeWidth": "3", "stroke": "orange" } }, { "source": "30", "target": "35", "id": "xy-edge__30-35", "selected": false, "style": { "strokeWidth": "3", "stroke": "orange" } }, { "source": "35", "target": "40", "id": "xy-edge__35-40", "selected": false, "style": { "stroke": "blue" }, "type": "bezier" }, { "source": "40", "target": "45", "id": "xy-edge__40-45" }, { "source": "45", "target": "50", "id": "xy-edge__45-50", "type": "bezier", "style": { "stroke": "wheat", "strokeWidth": "3" } }, { "source": "21", "target": "50", "id": "xy-edge__21-50", "type": "smoothstep", "style": { "strokeWidth": 2, "stroke": "orange" } }, { "source": "31", "target": "40", "id": "xy-edge__31-40", "selected": false, "type": "bezier", "style": { "strokeWidth": 2, "stroke": "orange" } }, { "source": "3", "target": "15", "id": "xy-edge__3-15", "type": "smoothstep", "style": { "stroke": "black" }, "selected": false }, { "source": "14", "target": "19", "id": "xy-edge__14-19" }, { "source": "8", "target": "14", "id": "xy-edge__8-14", "style": { "strokeWidth": 2, "stroke": "skyblue" }, "type": "bezier", "selected": false }, { "source": "44", "target": "49", "id": "xy-edge__44-49" }, { "source": "36", "target": "50", "id": "xy-edge__36-50" }, { "source": "11", "target": "18", "id": "xy-edge__11-18", "selected": false, "style": { "stroke": "orange", "strokeWidth": "2" }, "type": "smoothstep" }, { "type": "bezier", "style": { "stroke": "skyblue", "strokeWidth": 2 }, "source": "24", "target": "34", "id": "xy-edge__24-34" }, { "type": "bezier", "style": { "stroke": "magenta", "strokeWidth": 2 }, "source": "7", "target": "15", "id": "xy-edge__7-15", "selected": false }, { "type": "bezier", "style": { "stroke": "skyblue", "strokeWidth": 2 }, "source": "2", "target": "15", "id": "xy-edge__2-15", "selected": false }, { "type": "bezier", "style": { "stroke": "skyblue", "strokeWidth": 2 }, "source": "34", "target": "randomnode_1755441372527", "id": "xy-edge__34-randomnode_1755441372527" }, { "type": "bezier", "style": { "stroke": "skyblue", "strokeWidth": 2 }, "source": "2", "target": "11", "id": "xy-edge__2-11" }, { "type": "bezier", "style": { "stroke": "skyblue", "strokeWidth": 2 }, "source": "25", "target": "30", "id": "xy-edge__25-30" }, { "type": "bezier", "style": { "stroke": "skyblue", "strokeWidth": 2 }, "source": "22", "target": "26", "id": "xy-edge__22-26" }, { "type": "bezier", "style": { "stroke": "skyblue", "strokeWidth": 2 }, "source": "randomnode_1755443045461", "target": "11", "id": "xy-edge__randomnode_1755443045461-11" }, { "type": "bezier", "style": { "stroke": "skyblue", "strokeWidth": 2 }, "source": "41", "target": "48", "id": "xy-edge__41-48" }, { "type": "bezier", "style": { "stroke": "skyblue", "strokeWidth": 2 }, "source": "randomnode_1755441372527", "target": "40", "id": "xy-edge__randomnode_1755441372527-40" }]




const SaveRestore = () => {
  //////////////////////////////////////////////////////////////////////////////////////////////update nodes
  const [nodes, setNodes, onNodesChange] = useNodesState([]);
  const [edges, setEdges, onEdgesChange] = useEdgesState([]);
  const [id, setId] = useState();
  const [nodeName, setNodeName] = useState();
  const [nodeSource, setNodeSource] = useState();
  const [nodeTarget, setNodeTarget] = useState();
  const [nodeBg, setNodeBg] = useState();
  const [nodeHidden, setNodeHidden] = useState(false);

  const [idEdge, setIdEdge] = useState();
  const [edgeType, setedgeType] = useState();
  const [edgeStroke, setEdgeStroke] = useState();
  const [edgeStrokeWidth, setEdgeStrokeWidth] = useState();
  const { idnew } = useParams()

  useEffect(() => {
    get()
  }, []);

  const get = async () => {
    await fetch(`${process.env.REACT_APP_URL}/api/curses/mesh/${idnew}`)
      .then((response) => response.json())
      .then((data) => {
        setNodes(data.items[0].nodes)
        setEdges(data.items[0].edges)
        console.log(data.items[0].nodes)
      })
      // .then(response => response.json())
      // .then(data => { toast.warning(data); get() })
      .catch(error => console.error(error))
  }


  useEffect(() => {
    setNodes((nds) =>
      nds.map((node) => {
        if (node.id === id) {
          return {
            ...node,
            data: {
              ...node.data,
              label: nodeName,
            },
          };
        }

        return node;
      }),
    );
  }, [nodeName, setNodes]);

  useEffect(() => {
    setNodes((nds) =>
      nds.map((node) => {
        if (node.id === id) {
          return {
            ...node,
            sourcePosition: nodeSource,
          };
        }

        return node;
      }),
    );
  }, [nodeSource, setNodes]);

  useEffect(() => {
    setNodes((nds) =>
      nds.map((node) => {
        if (node.id === id) {
          return {
            ...node,
            targetPosition: nodeTarget,
          };
        }

        return node;
      }),
    );
  }, [nodeTarget, setNodes]);





  useEffect(() => {
    setNodes((nds) =>
      nds.map((node) => {
        if (node.id === id) {
          return {
            ...node,
            style: {
              ...node.style,
              backgroundColor: nodeBg,
            },
          };
        }

        return node;
      }),
    );
  }, [nodeBg, setNodes]);






  useEffect(() => {
    setNodes((nds) =>
      nds.map((node) => {
        if (node.id === id) {
          return {
            ...node,
            hidden: nodeHidden,
          };
        }

        return node;
      }),
    );
    setEdges((eds) =>
      eds.map((edge) => {
        if (edge.id === 'e1-2') {
          return {
            ...edge,
            hidden: nodeHidden,
          };
        }

        return edge;
      }),
    );
  }, [nodeHidden, setNodes, setEdges]);





  //////////////////////////////////////////////////////////////////////////////

  useEffect(() => {
    setEdges((nds) =>
      nds.map((edge) => {
        // console.log(edge)
        // console.log(edgeType, idEdge)
        if (edge.id === idEdge) {
          return {
            ...edge,
            type: edgeType,
          };
        }

        return edge;
      }),

    );
  }, [edgeType, setEdges]);





  useEffect(() => {
    setEdges((nds) =>
      nds.map((edge) => {
        if (edge.id === idEdge) {
          return {
            ...edge,
            style: {
              ...edge.style,
              strokeWidth: edgeStrokeWidth,
            },
          };
        }

        return edge;
      }),
    );
  }, [edgeStrokeWidth, setEdges]);



  useEffect(() => {
    setEdges((nds) =>
      nds.map((edge) => {
        if (edge.id === idEdge) {
          return {
            ...edge,
            style: {
              ...edge.style,
              stroke: edgeStroke,
            },
          };
        }

        return edge;
      }),
    );
  }, [edgeStroke, setEdges]);



  const onNodeClick = (event, node) => {
    // event.preventDefault()
    setId(node._id)
    setIdEdge()
    setNodeName(node.data.label)
    setId(node.id)
    setNodeBg(node.style ? node.style.backgroundColor : '')
    setNodeSource(node.sourcePosition)
    setNodeTarget(node.targetPosition)
    console.log('Clicked Node ID:', node);
  }
  const onEdgeClick = (event, node) => {
    // event.preventDefault()
    setId()
    setIdEdge(node.id)
    setedgeType(node.type)
    setEdgeStroke(node.style.stroke)
    setEdgeStrokeWidth(node.style.strokeWidth)
    console.log('Clicked Node ID:', node.style.strokeWidth, node.type);
  }

  //////////////////////////////////////////////////////////////////////////////////////////////


  const [rfInstance, setRfInstance] = useState(null);
  const { setViewport } = useReactFlow();

  const onConnect = useCallback(
    (params) => setEdges((eds) => addEdge(params, eds)),
    [setEdges],
  );

  const onSave = useCallback(() => {
    if (rfInstance) {
      const flow = rfInstance.toObject();
      localStorage.setItem(flowKey, JSON.stringify(flow))
      fetch(process.env.REACT_APP_URL + "/api/curses/mesh/" + idnew, {
        method: 'put',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: flow,
          title: "title",
        })
      })
        .then(response => response.json())
        .then(data => { toast.info(data); get() })
        .catch(error => console.error(error))
    }
  }, [rfInstance]);

  const onRestore = useCallback(() => {
    const restoreFlow = async () => {
      const flow = JSON.parse(localStorage.getItem(flowKey));
      console.log(localStorage.getItem(flowKey))

      if (flow) {
        const { x = 0, y = 0, zoom = 1 } = flow.viewport;
        setNodes(flow.nodes || []);
        setEdges(flow.edges || []);
        setViewport({ x, y, zoom });
      }
    };

    restoreFlow();
  }, [setNodes, setViewport]);

  const onAdd = useCallback(() => {
    const newNode = {
      id: getNodeId(),
      data: { label: 'Added node' },
      position: {
        x: (Math.random() - 0.5) * 400,
        y: (Math.random() - 0.5) * 400,
      },
      sourcePosition: 'right',
      targetPosition: 'left',
    };
    setNodes((nds) => nds.concat(newNode));
  }, [setNodes]);


  const edgeReconnectSuccessful = useRef(true);

  const onReconnectStart = useCallback(() => {
    edgeReconnectSuccessful.current = false;
  }, []);

  const onReconnect = useCallback((oldEdge, newConnection) => {
    edgeReconnectSuccessful.current = true;
    setEdges((els) => reconnectEdge(oldEdge, newConnection, els));
  }, []);

  const onReconnectEnd = useCallback((_, edge) => {
    if (!edgeReconnectSuccessful.current) {
      setEdges((eds) => eds.filter((e) => e.id !== edge.id));
    }

    edgeReconnectSuccessful.current = true;
  }, []);


  return (
    <ReactFlow
      nodes={nodes}
      edges={edges}
      // edgeTypes={edgeTypes}
      onNodesChange={onNodesChange}
      onEdgesChange={onEdgesChange}
      onConnect={onConnect}
      onInit={setRfInstance}
      onReconnect={onReconnect}
      fitView
      // fitViewOptions={{ padding: .5 }}
      onReconnectStart={onReconnectStart}
      onReconnectEnd={onReconnectEnd}
      onNodeClick={onNodeClick}
      onEdgeClick={onEdgeClick}
      defaultEdgeOptions={defaultEdgeOptions}
      snapToGrid={true}
      snapGrid={snapGrid}
    >
      {/* <Controls /> */}
      <Background />
      <Panel position="top-right">
        <button className="xy-theme__button" onClick={onAdd}> add node </button>
        {/* <button className="xy-theme__button" onClick={onRestore}> restore </button> */}
        <button className="xy-theme__button" onClick={onSave}> save </button>
      </Panel>
      {id ?
        <Panel position="bottom-left" style={{ width: 350, backgroundColor: 'orange', padding: '1em' }}>
          <label className="xy-theme__label">Label: </label>
          <input
            value={nodeName}
            onChange={(evt) => setNodeName(evt.target.value)}
            className="xy-theme__input"
          />
          <div>

            <label className="xy-theme__label">Source: </label>
            <select name="select" onChange={(evt) => setNodeSource(evt.target.value)} className="xy-theme__input">
              <option value="left" selected={nodeSource == 'left'}>left</option>
              <option value="right" selected={nodeSource == 'right'}>Right</option>
              <option value="top" selected={nodeSource == 'top'}>Top</option>
              <option value="bottom" selected={nodeSource == 'bottom'}>Bottom</option>
            </select>
          </div>
          <div>

            <label className="xy-theme__label">Target </label>
            <select name="select" onChange={(evt) => setNodeTarget(evt.target.value)} className="xy-theme__select">
              <option value="left" selected={nodeSource == 'letf'}>left</option>
              <option value="right" selected={nodeSource == 'right'}>Right</option>
              <option value="top" selected={nodeSource == 'top'}>Top</option>
              <option value="bottom" selected={nodeSource == 'bottom'}>Bottom</option>
            </select>
          </div>
          <div>

            <label className="xy-theme__label">Background: </label>
            <input
              value={nodeBg}
              onChange={(evt) => setNodeBg(evt.target.value)}
              className="xy-theme__input"
            />
          </div>
          <div></div>
          <label className="xy-theme__label">Hidden:</label>
          <input
            type="checkbox"
            checked={nodeHidden}
            onChange={(evt) => setNodeHidden(evt.target.checked)}
            className="xy-theme__checkbox"
          />
        </Panel> : ''}

      {idEdge ?
        <Panel position="bottom-left" style={{ width: 350, backgroundColor: 'orange', padding: '1em' }}>

          <label className="xy-theme__label">Type: </label>
          <select name="select" onChange={(evt) => setedgeType(evt.target.value)} className="xy-theme__input">
            <option value="straight" selected={edgeType === 'straight'}>straight</option>
            <option value="bezier" selected={edgeType === 'bezier'}>bezier</option>
            <option value="step" selected={edgeType === 'step'}>step</option>
            <option value="smoothstep" selected={edgeType === 'smoothstep'}>smoothstep</option>
          </select>
          <div>
            <label className="xy-theme__label">Strokewidth </label>
            <input
              value={edgeStrokeWidth}
              onChange={(evt) => setEdgeStrokeWidth(evt.target.value)}
              className="xy-theme__input"
            />
          </div>
          <div>

            <label className="xy-theme__label">Stroke: </label>
            <input
              value={edgeStroke}
              onChange={(evt) => setEdgeStroke(evt.target.value)}
              className="xy-theme__input"
            />
          </div>
        </Panel> : ''}
    </ReactFlow>
  );
};

export default () => (
  <div style={{ width: '100vw', height: '89vh' }}>
    <ReactFlowProvider>
      <SaveRestore />
    </ReactFlowProvider>
    <ToastContainer
      position="top-right" autoClose={1000} hideProgressBar={false} newestOnTop={false} closeOnClick={true} rtl={false} pauseOnFocusLoss={false} draggable pauseOnHover={false} closeButton={false}
    />

  </div>
);


